import React from 'react';

export default function ComingSoonBadge({ dark = false, className = '' }) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 font-mono text-[0.68rem] font-medium uppercase tracking-[0.16em] ${
        dark ? 'bg-fusion-ember/15 text-[#FFB08F] ring-1 ring-fusion-ember/30' : 'bg-fusion-ember/10 text-[#C2410C] ring-1 ring-fusion-ember/25'
      } ${className}`}
    >
      <span className="relative flex size-2">
        <span className="absolute inline-flex size-full animate-ping rounded-full bg-fusion-ember opacity-60" />
        <span className="relative inline-flex size-2 rounded-full bg-fusion-ember" />
      </span>
      Coming soon
    </span>
  );
}
